<template>
    <div class="step-test-email col-12">
        <div class="form-group field required">
            <label :for="inputId">{{ inputLabel }}</label>
            <input
                :placeholder="inputPlaceholder"
                type="email"
                class="form-control"
                :id="inputId"
                v-model="testValue"
                required
            />
        </div>

        <!-- Slot for extra content -->
        <slot name="extra" />

        <div class="action-buttons mt-4">
            <button class="btn btn-secondary" @click="$emit('back')">{{ t('settings-connections-steps-back') }}</button>
            <button class="btn btn-success" @click="sendTest" :disabled="!testValue || testing">
                <Icon icon-class="ui-send-01" size="4" />
                <span v-if="!testing">{{ t('settings-connections-steps-send_test') }}</span>
                <span v-if="testing">{{ t('settings-connections-steps-sending_test') }}</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StepTestEmail',
    props: {
        /**
         * Input label
         */
        inputLabel: {
            type: String,
            default: 'Digite um e-mail',
        },
        /**
         * Input placeholder
         */
        inputPlaceholder: {
            type: String,
            default: 'exemplo@email.com',
        },
        /**
         * Input id for label association
         */
        inputId: {
            type: String,
            default: 'test-email',
        },
        /**
         * Whether test is in progress
         */
        testing: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            testValue: null,
        };
    },
    methods: {
        sendTest() {
            this.$emit('test', this.testValue);
        },
        reset() {
            this.testValue = null;
        },
    },
};
</script>

<style scoped lang="less">
.step-test-email {
    .form-group {
        margin-top: 80px;
    }

    .action-buttons {
        display: flex;
        gap: 12px;
        justify-content: stretch;
        
        button {
            flex: 1;
            justify-content: center;
        }
    }
}
</style>

